import { FUser } from 'libs/graphql/fragment/__generated__/FUser';
import { PartialDeep } from 'type-fest';

export interface IUserState {
    loggedUser: PartialDeep<FUser>;
    loggedUserChecked: boolean;
    dbLikelyCrashed: boolean;
}

export const initialUserState = {
    loggedUser: null,
    loggedUserChecked: false,
    dbLikelyCrashed: false
};
